export default __webpack_public_path__ + "static/media/Image-6.48962c49.jpg";